import Alpine from 'alpinejs';
import ajax from '@imacrayon/alpine-ajax';
import htmx from 'htmx.org';

// Register Alpine AJAX plugin
Alpine.plugin(ajax);

window.Alpine = Alpine;
window.htmx = htmx;

// Configure Alpine AJAX with WordPress nonce
document.addEventListener('alpine:init', () => {
    const wpNonce = window.wpApiSettings?.nonce || window.nonce;
    
    if (wpNonce) {
        // Configure Alpine AJAX headers
        Alpine.store('ajax', {
            headers: {
                'X-WP-Nonce': wpNonce,
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });
    }
});

// Configure HTMX if nonce is available
const wpNonce = window.wpApiSettings?.nonce || window.nonce;
if(wpNonce) {
    document.addEventListener('htmx:configRequest', function(event) {
        event.detail.headers['X-WP-Nonce'] = wpNonce;
    });
}

document.addEventListener('DOMContentLoaded', function() {
    Alpine.start();
});

// Alpine.magic('blockData', (el, { Alpine }) => {
//     // el.parentElement.id is the key of the blockData object
//     let blockData = Alpine.store('blockData')[el.parentElement.id];
//     return blockData;
// });